define(function (require, exports) {
    'use strict';
     // @ngInject
    exports.scamWarning = function (TEMPLATE_PATH) {
        return {
            restrict: 'E',
            scope: {
                startjourney: '=?startjourney',
                request: '=?request',
                submit: '&submit',
                addjourney:'&addjourney',
                endjourney: '&endjourney',
                paymentjourney:'=?paymentjourney'
            },

            controller: /* @ngInject */ function ($scope,$filter,$timeout, $element, $log, metroTransmit, metroUiHandler, lpCoreBus, lpUsersAuthentication, metroContext, metroTagging, metroMeta) {
                $scope.scamWarning_array=[
                    { 
                        id:'1',
                        name:'Paying a bill or invoice for a service',
                        heading:'Were you expecting to make this payment?',
                        desc:"Paying for a service from a new business or someone you’ve used before.",
                        moredesc:"Making a payment for an bill/invoice – even if it’s from someone you’ve used before – confirm that the correspondence is genuine, and you're not communicating with a fraudster.",
                        data:[
                            'Ensure you & your employees verify any new or amended account details by contacting them in a different way to how they contacted you.',
                            'Phone numbers & email address can be manipulated - Check that the phone number and email address are exactly the same as the ones you have used before.',
                            'Have you received the goods/services you’re paying for?',
                        ]
                    },            
                    {
                        id:'2',
                        name:'Buying Goods or Services in person or online',
                        heading:'Are you sure that what you’re paying for exists?',
                        desc:"Paying for something to a new company or person you don’t know.",
                        moredesc:"If you’re buying from a company or person you don’t know, do some research before sending money.",
                        data:[
                            'Never make a purchase away from the selling platform, as you will lose your buyer protection. Pay using your card or a secure payment platform.',
                            'Make sure independent reviews of the seller and product are positive & from genuine customers.',
                            'Don’t pay the full amount without seeing the product in a live environment – consider a deposit option.',
                            'Remember that if a deal seems too good to be true, it probably is',
                        ]
                    }, 
                    {
                        id:'3',
                        name:'Following payment instructions from your Boss or Employee?',
                        heading:'Have you been asked to urgently process a payment by a senior manager or amend an employee’s existing payment details?',
                        desc:'Making a payment following a request from ‘someone’ within your company.',
                        moredesc:'',
                        data:[
                            'Double-check that it’s really them, by contacting them in a different way to how they contacted you. If you can’t speak to them, <b>DO NOT</b> make a payment.',
                            'Phone numbers & email address can be manipulated - Check that the phone number and email address are exactly the same as the ones you have used before.',
                            'Never make payments out of the ordinary or divert from your usual company process. Scammers will create elaborate stories to trick you into sending your money to them.',
                            
                        ]
                    }, 
                    {
                        id:'4',
                        name:'Paying HMRC or a local authority',
                        heading:'Are you being pressurised in to acting quickly to make this payment?',
                        desc:'Making a payment to someone claiming to be HMRC, the police or an authority.',
                        moredesc:'If you weren’t expecting to make a payment and are being pressured or threatened – for example with fines or a prison sentence – <span class="text-red">STOP!</span>',
                        data:[
                            '<b>Never</b> make a payment of this type to an account with a personal name.',
                            'If you are making a scheduled payment to HMRC, make sure you check the account details on the official gov.uk website before sending.',
                            'Beware of ‘spoofing’: people can disguise their phone number to look like one you recognise',
                            'Government officials and local authorities will never call, email or text you demanding an immediate payment. ',
                            'If you are being pressured or threatened to make a payment –<b> DON’T.</b>',
                        ]
                    }, 
                    {
                        id:'5',
                        name:"Moving money to another account or a ‘safe account’",
                        heading:'Have you had a call from ‘your bank’ and been told you must move money? Don’t – it’s a scam!',
                        desc:'You have been told to move your money to another account.',
                        moredesc:'If someone claims to be from Metro Bank, another bank or law enforcement and asks you to transfer money to a ‘safe’ account - it’s a fraudster.',
                        data:[
                            'Your bank or law enforcement will never call, email or text you demanding make any payments',
                            'Beware of ‘spoofing’: people can disguise their phone number to look like one you recognise.',
                            'Your bank or law enforcement will never open a new bank account on your behalf or ask you to support an investigation by handing money over.',
                            'Criminals may have basic information about you or your company (i.e. name, address, account details) - do not assume a caller is genuine because they have these details ',
                            'If you are being pressured or threatened to make a payment – <b>DON’T.</b>',
                        ]
                    }, 
                    {
                        id:'6',
                        name:'Make an investment or buying cryptocurrency',
                        heading:'Carry out research to ensure you’re investing via a FCA-registered firm or individual - If not, STOP!',
                        desc:'Making a payment to invest in a financial opportunity.',
                        moredesc:'If you’ve suddenly been contacted with an investment opportunity, it’s likely to be a scam.',
                        data:[
                            'Check that the company or stockbroker is FCA-registered. Always use the contact details from the FCA site, to avoid scammers who clone genuine company websites.',
                            'Avoid using your business account for Crypto related investments.',
                            'Remember that pressure to make a quick decision or returns seeming too good to be true, means this is likely to be a scam.',
                        ]
                    }, 
                    {
                        id:'7',
                        name:'Something else?',
                        heading:'Are you being rushed or into making this payment?',
                        desc:"Paying for something you weren’t expecting to pay for.",
                        moredesc:"Take time to think about the payment you’re making. ",
                        data:[
                            'Consider paying by card, or through a secure payment platform.',
                            'Criminals can impersonate people or companies by manipulating email addresses or phone numbers - Always verify who you’re speaking with by contacting them in a different way to how they contacted you.',
                            'A scammer will often guide you through the process and tell you what to do or apply fear and pressure tactics to encourage you to act quickly.',
                            'If you’ve been encouraged to choose this option by the person you’re communicating with – they’re likely to be a fraudster. <b>STOP</b> & think before sending any money',
                        ]
                    }, 
                ];
                $scope.selObject = {};
                $scope.scamWarning = true;
                $scope.scamWarning_step1 = true;
                $scope.scamWarning_step2 = false;
                $scope.showAddPayeeBtn = true;
                $scope.btnStyle = "btnDisable";
                $scope.radioChecked = false;
                $scope.scamWarning_selected_option=0;

                $scope.addben = function () {
                    $scope.scamWarning_step1 = true;
                    $scope.scamWarning_step2 = false;
                    $scope.showAddPayeeBtn = true;
                    $scope.radioChecked = false;
                    $scope.btnStyle = "btnDisable";
                    sessionStorage.setItem('payment_reason', $scope.scamWarning_selected_option);
                    $scope.addjourney();
                }
                $scope.stopbenadding = function () {
                    $scope.scamWarning_step1 = true;
                    $scope.scamWarning_step2 = false;
                    $scope.showAddPayeeBtn = true;
                    $scope.radioChecked = false;
                    $scope.btnStyle = "btnDisable";
                    $scope.endjourney();
                }
                $scope.goto_scamWarning_step2 = function (val) {
                    $scope.scamWarning_selected_option=val;
                    $('.modal-content').scrollTop(0);
                    $scope.scamWarning_step1 = false;
                    $scope.scamWarning_step2 = true;
                   $scope.request =  $filter('filter')( $scope.scamWarning_array, {id: val})[0];

                 };
                 $scope.backToStep1 = function () {
                     if($scope.scamWarning_step2){
                    $scope.scamWarning_step1 = true;
                    $scope.scamWarning_step2 = false;
                    $scope.showAddPayeeBtn = true;
                    $scope.radioChecked = false;
                    $scope.btnStyle = "btnDisable";
                     }
                     else{
                        $scope.scamWarning =false;
                        $scope.endjourney();
                     }
                    
                 };
                 $scope.enableAddPayee =function(){
                    $scope.showAddPayeeBtn=!$scope.showAddPayeeBtn;
                    $scope.btnStyle=$scope.radioChecked?"btnDisable":"btnEnable";                   
                    $scope.radioChecked =!$scope.radioChecked;
                };

            },    
            templateUrl : TEMPLATE_PATH + 'scamWarning.html',
        };
    };
});


// WEBPACK FOOTER //
// ./scripts/directives/scamWarning.js